export default __webpack_public_path__ + "static/media/shashiHotel.90c88a6d.png";